import { FC, SVGProps } from 'react'

export const Link: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.008 8.66666C7.2943 9.04942 7.65957 9.36612 8.07903 9.59529C8.49849 9.82446 8.96233 9.96074 9.4391 9.99489C9.91586 10.029 10.3944 9.96024 10.8422 9.79318C11.2901 9.62613 11.6967 9.36471 12.0347 9.02666L14.0347 7.02666C14.6419 6.39799 14.9778 5.55598 14.9702 4.68199C14.9626 3.808 14.6121 2.97196 13.9941 2.35394C13.376 1.73591 12.54 1.38535 11.666 1.37775C10.792 1.37016 9.95 1.70614 9.32133 2.31333L8.17466 3.45333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.67465 7.33334C9.38835 6.95058 9.02308 6.63388 8.60362 6.40471C8.18416 6.17554 7.72031 6.03926 7.24355 6.00511C6.76679 5.97097 6.28826 6.03976 5.84042 6.20681C5.39258 6.37387 4.98591 6.63529 4.64799 6.97334L2.64799 8.97334C2.04079 9.60201 1.70481 10.444 1.71241 11.318C1.72 12.192 2.07056 13.028 2.68859 13.6461C3.30662 14.2641 4.14266 14.6147 5.01665 14.6222C5.89064 14.6298 6.73265 14.2939 7.36132 13.6867L8.50132 12.5467"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
